import { globalAdminRoles } from 'const/roles';
import { checkRoles } from 'helpers';

export const checkTenants = (roles: string[], currentTenantId: number, allowedTenants: number[]): boolean => {
  const isGlobalAdmin = checkRoles(roles || [], globalAdminRoles);
  return isGlobalAdmin ? true : allowedTenants.includes(currentTenantId);
};
